import { IProject } from '@/models/project.model';
import { domainEndpoint } from '@/api/axios';
import { domainStore } from '@/store/domain-store';

export default function useMapProject() {
  function mapConfig(project: IProject) {
    if ('map_settings' in project) {
      const mapsettings = project.map_settings;
      const sources = [];
      if (mapsettings.wms_base_layer_urls && Object.keys(mapsettings.wms_base_layer_urls).length > 0) {
        // multiple layers (not only wms, old var-name)
        // We have multiple sources of maps.

        // order layers alphabetically by key
        const ordered_layers = Object.keys(mapsettings.wms_base_layer_urls)
          .sort()
          .reduce(function (result: any, key: string) {
            result[key] = mapsettings.wms_base_layer_urls[key];
            return result;
          }, {});
        Object.keys(ordered_layers).forEach((key: string) => {
          const baseLayer = {
            base: true,
            crossorigin: false,
            group: 'Karten',
            title: key,
            type: 'map_overlay',
            url: ordered_layers[key].url,
            visible: true,
            attribution: mapsettings.attribution,
            wmsParams: null,
          };
          // siteadmin -> Mängelmelder -> Kartentyp (WMS-Karte) || wmsParams
          if (
            ordered_layers[key].mapType == 'wms' ||
            (!ordered_layers[key].mapType && mapsettings.type == 'wms') ||
            ordered_layers[key].wmsParams
          ) {
            baseLayer.type = 'map_overlay_wms';
            baseLayer.wmsParams = ordered_layers[key].wmsParams;
          } else {
            baseLayer.url = baseLayer.url.replace('${z}', '{z}');
            baseLayer.url = baseLayer.url.replace('${y}', '{y}');
            baseLayer.url = baseLayer.url.replace('${x}', '{x}');
          }
          sources.push(baseLayer);
        });
      } else {
        // default single layer
        const baseLayer = {
          base: true,
          crossorigin: false,
          group: 'Karten',
          title: 'Basiskarte',
          type: 'map_overlay',
          url: mapsettings.tiles.url,
          visible: true,
          attribution: mapsettings.attribution,
          wmsParams: null,
          xyzParams: null,
        };
        if (mapsettings.type == 'wms') {
          baseLayer.type = 'map_overlay_wms';
          baseLayer.wmsParams = mapsettings.type_parameters;
        } else if (mapsettings.type == 'xyz') {
          baseLayer.type = 'map_overlay_xyz';
          baseLayer.xyzParams = mapsettings.type_parameters;
        } else {
          baseLayer.url = baseLayer.url.replace('${z}', '{z}');
          baseLayer.url = baseLayer.url.replace('${y}', '{y}');
          baseLayer.url = baseLayer.url.replace('${x}', '{x}');
        }
        sources.push(baseLayer);
      }

      let base_url = process.env.VUE_APP_SERVER_BASE_URL;
      if (base_url == '/') {
        base_url = window.location.protocol + '//' + window.location.host;
      }

      // Extra layers
      if ('sources' in mapsettings && mapsettings.sources.length > 0) {
        mapsettings.sources.forEach(s => {
          // Per T17350, URL can lead to static folder (for map overlay) or to API endpoint
          const url = s.url.startsWith('/api/v1') ? base_url + s.url : s.url;
          sources.push({
            base: s.base == 1,
            format: s.format,
            group: s.group,
            opacity: s.opacity,
            style: s.style,
            dependant_style: s.dependant_style,
            title: s.title,
            type: s.type,
            url: url,
            infobox_uri: s.infobox_uri || null,
            visible: s.visible == 1,
            crossorigin: s.crossorigin == 1,
            transition: s.transition == 1,
            exclusive_visibility: s.exclusive_visibility == 1,
          });
        });
      }

      if ('map_layers' in project && project.map_layers.length > 0) {
        project.map_layers.forEach(s => {
          sources.push({
            base: 0,
            format: 'geojson',
            group: 'Gebiete',
            opacity: 1,
            style: s.style,
            dependant_style: s.dependant_style,
            title: s.geometry.display_name,
            type: 'geojson_overlay',
            url: base_url + s.geometry.geojson_uri,
            visible: 1,
            infobox_uri: s.infobox_uri,
          });
        });
      }

      const markerLayer = {
        group: 'Marker',
        title: domainStore.translate('thought.general.title-plural'),
        opacity: 1,
        type: 'marker_overlay',
        url: domainEndpoint() + '/thought/geojson',
        forceParams: {
          rows: 500,
          projectid: project.id,
        },
        visible: true,
        marker_legend: [] as any[],
      };
      if (mapsettings.marker_legend && mapsettings.marker_legend.length > 0) {
        markerLayer.marker_legend = mapsettings.marker_legend;
      }
      sources.push(markerLayer);

      return {
        bounds: mapsettings.bounds,
        lat: mapsettings.position.lat,
        lon: mapsettings.position.lon,
        zoom: mapsettings.zoom.default,
        maxZoom: mapsettings.zoom.max,
        minZoom: mapsettings.zoom.min,
        renderer: mapsettings.infobox_renderer !== '' ? mapsettings.infobox_renderer : 'Default',
        sources: sources,
        cluster_message_markers: false,
        create_marker_uri: mapsettings.create_marker_uri,
      };
    } else {
      return {};
    }
  }

  return {
    mapConfig,
  };
}
